export default {
  capability: {
    aerial_photo: 'Luftfoto',
    dnb: 'DNB layout',
    drone: 'Drone',
    high_end: 'Premium',
    mast_photo: 'Mastefoto',
    measurement: 'Oppmåling',
    panorama_photo: 'Panoramafoto',
    photo: 'Fotografering',
    photo_editing: 'Fotoredigering',
    floor_plan: 'Plantegning',
    residence: 'Residens',
    video: 'Video',
    interior_consulting: 'Boligstyling',
  },
  bookingState: {
    pending: 'Ikke booket',
    booked: 'Ikke fullført',
    cancelled: 'Kansellert',
    completed: 'Fullført',
    failed: 'Bomtur',
  },
  invoiceLineState: {
    awaiting_delivery: 'Venter på leveranse',
    awaiting_delivery_and_review: 'Venter på leveranse og godkjenning av endringer',
    awaiting_first_time_review: 'Venter på første godkjenning av endringer',
    awaiting_review: 'Venter på godkjenning av endringer',
    cancelled: 'Kansellert',
    changes_accepted: 'Godkjent',
    changes_rejected: 'Avslått',
    delivered: 'Tilhørende produkt(er) levert',
    first_time_review_rejected: 'Avslått',
    invoiced: 'Fakturert',
    never_to_be_invoiced: 'Endelig avslått',
    ready_for_invoice: 'Klar til fakturering',
    undetermined: 'Ubestemt',
  },
  productState: {
    booked: 'Ikke innlevert',
    cancelled: 'Kansellert',
    delivered: 'Levert kunde',
    delivery_cancelled: 'Levering kansellert',
    downloading: 'Lastes ned',
    lacking_input: 'Avventer meglers underlag',
    presubmitted: 'Innlevert',
    production_completed: 'Produksjon ferdig',
    production_failed: 'Feil under produksjon',
    production_in_progress: 'Under produksjon',
    ready_for_booking: 'Klar for booking',
    submitted: 'Innlevert',
    undetermined: 'Uavklart',
    waiting_for_input: 'Avventer underlag',
  },
  products: {
    StandardPhoto: 'Standard foto',
    RegularPhotoResidence: 'Residensfoto',
    MastPhoto: 'Mastefoto',
    Panorama180Photo: 'Panoramafoto',
    Measurement: 'Oppmåling',
    DronePhoto: 'Dronefoto',
    HighEndPhoto: 'Premium',
    FacadePhoto: 'Fasadebilde',
    InteriorConsulting: 'Boligstyling',
    InteriorCopyWriting: 'Boligstyling assistanse',
    VirtualTour: 'Digital visning',
  }
}
